<template>
  <div class="page">
    <!--ヘッダーここから-->
    <IndexHeader :title="setting.title.split('\n').join('<br/>')" />
    <!--ヘッダここまでー-->
    <!--start画面ここから-->
    <div class="container">
      <div class="start-headder">
        <div
          class="return"
          @click="back"
          v-text="!showConfig ? '一覧へ' : '戻る'"
        ></div>
        <div>
          <img
            v-if="!showConfig"
            src="@/assets/img/btn_setting.png"
            class="btn_setting"
            alt="設定"
            @click="showConfig = true"
          />
          <img v-else style="opacity: 0" src="@/assets/img/btn_setting.png" />
        </div>
      </div>
      <!--選択した目次-->
      <div v-if="!showConfig">
        <div class="record-memo">
          <p id="checked-mokuji">{{ drill.title }}</p>
          <div class="progress">
            <div
              class="progress-bar progress-bar-info"
              :style="{ width: `${lastPercent}%` }"
            ></div>
          </div>
          <div v-if="lastData">
            <p class="last-title">前回の結果</p>
            <div class="lastdata-wrap">
              <div class="lastdata">
                <p id="last-time">
                  <span>
                    {{ lastDate }}
                  </span>
                </p>
              </div>
              <div class="lastdata">
                <p id="last-results">
                  <span>
                    {{ lastData.data.length }}問中
                    <span id="last-userscore">{{ lastCorrectNum }}</span
                    >問正解
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- STARTボタン -->
        <ol class="btn-start">
          <li @click="$emit('start')">&nbsp;START!</li>
        </ol>
        <!--前回正解の問題は除く-->
        <div class="checkbox" v-if="avilableFaultQuestions">
          <input
            type="checkbox"
            id="start-checkbox"
            name="start-checkbox"
            checked="checked"
            v-model="isExpectLastCorrect"
          />
          <label for="start-checkbox" class="start-checkbox"
            >前回正解の問題は除く</label
          >
        </div>
        <!--チャ太郎-->
        <div class="start-comment">
          <img
            src="@/assets/img/chatarou_7.png"
            class="chatarou_start animated slideInLeft"
            alt="チャ太郎"
          />
          <div class="start-comment-box animated bounceIn">
            <p class="start-comment">今日も頑張ろう！</p>
          </div>
        </div>
      </div>

      <Config
        :drill="drill"
        :config="config"
        @setConfig="setConfig"
        @showConfig="showConfig = !showConfig"
        v-else
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import moment from "moment";

import IndexHeader from "@/components/parts/IndexHeader.vue";
import Config from "@/components/questionPages/Start/Config.vue";

import setConfig from "@/components/setConfig";

export default {
  name: "StartIndex",
  components: { IndexHeader, Config },
  data() {
    return {
      showConfig: false,
      isExpectLastCorrect: false
    };
  },
  created() {
    this.initConfig();
    this.isExpectLastCorrect = Boolean(this.expectLastCorrect);
  },
  mounted() {
  },
  computed: {
    fixConfig() {
      const keys = ["limit", "continue", "random", "audio"];
      const retObj = {};
      keys.forEach(elm => {
        if (this.drill.config) {
          if (this.drill.config[elm] !== null) {
            retObj[elm] = true;
            return;
          }
        }
        retObj[elm] = false;
      });
      return retObj;
    },
    expectLastCorrect() {
      return this.config.expectLastCorrect;
    },
    drill() {
      return this.$store.getters.drill;
    },
    setting() {
      return this.$store.state.setting;
    },
    config() {
      return this.$store.state.config;
    },
    lastData() {
      const history = localStorage.getItem(
        `SukenDrill::${this.setting.id}_${this.drill.id}::HISTORY`
      );

      if (history) {
        return JSON.parse(history);
      } else {
        return null;
      }
    },

    lastQuestions() {
      const qa = localStorage.getItem(
        `SukenDrill::${this.setting.id}_${this.drill.id}::QUESTIONANSWER`
      );
      if (qa) {
        return JSON.parse(qa);
      }
      return null;
    },

    lastDate() {
      if (this.lastData) {
        return moment(this.lastData.date).format("YYYY年MM月DD日 HH時mm分");
      }
      return null;
    },
    lastCorrectNum() {
      if (this.lastData) {
        return this.lastData.data.filter(e => e.tof === true).length;
      }
      return null;
    },
    lastPercent() {
      if (this.lastQuestions) {
        const correctQuestion = this.lastQuestions.filter(e => e === true)
          .length;
        const allQuestion = this.lastQuestions.length;
        return (correctQuestion / allQuestion) * 100;
      }
      return 0;
    },
    avilableFaultQuestions() {
      if (!this.lastQuestions) {
        return false;
      }

      const lastAll = this.lastQuestions.length;

      // const lastCorrect = this.lastQuestions.filter(e => e === true).length;
      const lastIncorrect = this.lastQuestions.filter(e => e !== true).length;

      console.log('lastAll', lastAll,'lastIncorrect', lastIncorrect)

      // 全問出題でない
      if (lastAll > this.drill.questions.length) {
        // 不正解がいくつかある
        return lastIncorrect  <
          this.drill.questions.length
      }
      // 全問出題
      return lastIncorrect > 0
    }
  },
  beforeDestroy() {},
  methods: {
    initConfig() {
      console.log("initConfig");
      const initConfig = this.drill.config;

      const configs = [
        "limitTime",
        "limit",
        "continue",
        "random",
        "audio",
        "expectLastCorrect"
      ];

      const commonSettings = ["continue", "random", "audio"];

      const defaultSetting = {
        limitTime: initConfig.limitTime || 10,
        limit: initConfig.limit || false,
        expectLastCorrect: initConfig.expectLastCorrect || false,
        continue: initConfig.continue || false,
        random: initConfig.random || false,
        audio: initConfig.audio || false,
      };

      configs.forEach(key => {
        let value, ls;
        let notLS = false;

        /*
        if (key === "limitTime" || key === "expectLastCorrect") {
          ls = localStorage.getItem(
            `SukenDrill::${this.setting.id}_${this.drill.id}::${key}`
          );
        } else {
          ls = localStorage.getItem(`SukenDrill::${this.setting.id}::${key}`);
        }
        */
        if (commonSettings.indexOf(key) !== -1) {
          ls = localStorage.getItem(
            `SukenDrill::${this.setting.id}::${key}`
          );
        } else {
          ls = localStorage.getItem(
            `SukenDrill::${this.setting.id}_${this.drill.id}::${key}`
          );
        }

        console.log(key, ls, typeof ls);

        if (ls && ls !== "undefined") {
          value = JSON.parse(ls);
        }

        console.log("fix", this.fixConfig[key], "init", initConfig[key]);
        if (
          (this.fixConfig[key] !== null && this.fixConfig[key] !== undefined) &&
          (initConfig[key] !== null && initConfig[key] !== undefined)
        ) {
          value = initConfig[key];
          notLS = true;
        }

        if (value === null || value === undefined) {
          value = defaultSetting[key];
        }

        console.log(key, value);
        this.setConfig({
          key,
          value,
          notLS
        });
      });
    },
    setConfig: setConfig,
    back() {
      if (!this.showConfig) {
        this.$store.commit("home");
        return;
      }
      this.showConfig = false;
    }
  },
  watch: {
    isExpectLastCorrect(nv) {
      this.setConfig({
        key: "expectLastCorrect",
        value: nv
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  display: flex;
  height: auto;
  flex-direction: column;
  overflow: visible;
}

.container {
  overflow: visible;
}

.last-title {
  margin: 0;
}

.last-data p {
  margin: 0;
}

#last-time,
#last-results {
  margin: 0;
}

#last-results {
  margin-left: 0.5em;
}

#last-time::before,
#last-results::before {
  display: inline-block;
  width: 40px;
  height: 40px;
  top: 0;
  left: 0;
  vertical-align: middle;
  margin: 0;
}
</style>
